import "./commonatoms.css";
import crossIcon from "../../assets/Icon-area-16.svg";
import IconAndTextButton from "./Buttons/IconAndTextButton";

const Tag = ({
  clsNames = "",
  styles = {},
  text = "",
  withIconFunc = false,
  onClickFnIcon = () => {},
  onClickFnTag = () => {},
  iconProps = {
    clsNames: "",
    iconStyles: {},
    iconPos: "left",
    icon: crossIcon,
  },
}) => {
  return (
    <div style={{...styles, fontFamily: "var(--db-font-secondary)"}} className={clsNames} onClick={onClickFnTag}>
      {text}
      {withIconFunc && (
        <IconAndTextButton
          clsNames={iconProps?.clsNames}
          icon={iconProps?.icon}
          iconPos={iconProps?.iconPos}
          iconStyles={iconProps?.iconStyles}
          onClickFn={onClickFnIcon}
        />
      )}
    </div>
  );
};

export default Tag;

// This component renders a tag with optional text and an icon button.
// The tag can be clicked to trigger an action, and the icon button can also trigger a separate action.
